import { SettingsAdminActiveDirectoryDetailsContainer } from 'modules/settings/pods/settings-integrations/settings-integrations-active-directory/settings-integrations-active-directory-details.container';
import { useParams } from 'react-router';

export const SettingsActiveDirectoryDetailsScene = () => {
    const { activeDirectoryId } = useParams();
    return <SettingsAdminActiveDirectoryDetailsContainer activeDirectoryId={activeDirectoryId} />;
};

export default SettingsActiveDirectoryDetailsScene;
